import React from 'react';
import PropTypes from 'prop-types';
import { has, get, orderBy } from 'lodash';
import withData from '@bd/bdcore-data';
import { buildThumbnailUrl, SanitizeHtml } from '@bd/bdcore-utilities';
import { Link } from '@bd/bdcore-named-routes';
import moment from 'moment';
import PageHelmet from '@bd/bdcore-pagehelmet';


import Header from '../../components/Header';
import Footer from '../../components/Footer';
import InsideHeader from '../../components/InsideHeader';
import MenuAbout from '../../components/MenuAbout';
import TestimonialBanner from '../../components/TestimonialBanner';
import CtaBanner from '../../components/CtaBanner';

function Blogpost({ blogpost, blogposts, page }) {
  return (
    <div>
      <PageHelmet blogpost={blogpost} />
      <Header />
      <InsideHeader h1="Latest News" background={page.page_image.contentUrl} />
      <MenuAbout />
      <div className="container blogpost-detail">
        <div className="row">
          <div className="col-lg-8">
            <div className="result-media">
              <img src={buildThumbnailUrl(get(blogpost, 'logo.contentUrl'), { width: 800, height: 800 })} alt="" />
            </div>
            <div className="result-content">
              <h2>{blogpost.title}</h2>
              <h3>
                {
                  has(blogpost, 'date') &&
                  moment(get(blogpost, 'date')).format('MMMM D, YYYY')
                }
              </h3>
              <p dangerouslySetInnerHTML={SanitizeHtml(get(blogpost, 'htmlbody', ''))} />
            </div>
          </div>
          <div className="col-lg-3 ml-auto blogpost-detail-list">
            <ul>
              <h3>The Latest News</h3>
              {
                orderBy(blogposts, ['date'], ['desc']).slice(0, 10).map(post => (
                  <li key={post._id}>
                    <Link
                      name="latest-news"
                      params={{
                        blogpostTitle: post.title,
                      }}
                    >
                      {get(post, 'title', '')}
                    </Link>
                  </li>
                ))
              }
            </ul>
          </div>
        </div>
      </div>
      <CtaBanner />
      <TestimonialBanner />
      <Footer />
    </div>
  );
}

Blogpost.propTypes = {
  page: PropTypes.object.isRequired,
  blogpost: PropTypes.object.isRequired,
  blogposts: PropTypes.arrayOf(PropTypes.object),
};

Blogpost.defaultProps = {
  blogposts: [],
};

export default withData({
  blogpost: true,
  blogposts: true,
  page: 'latest_news',
}, {
  required: {
    blogpost: true,
    page: true,
  },
})(Blogpost);



// WEBPACK FOOTER //
// ./src/pages/LatestNews/detail.js